/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _module = __webpack_require__(1);
	
	var mediaQueryMd = window.matchMedia('(min-width: 768px)');
	var mediaQueryLg = window.matchMedia('(min-width: 1024px)');
	
	(0, _module.smoothScroll)();
	
	(0, _module.showYouTubeModal)();
	
	var scrollAnimation = function scrollAnimation() {
	  var controller = new ScrollMagic.Controller();
	  var sceneStory = void 0;
	  var sceneCharaJunnaIllust = void 0,
	      sceneCharaJunnaBody = void 0,
	      sceneCharaJunnaName = void 0;
	  var sceneCharaNanaIllust = void 0,
	      sceneCharaNanaBody = void 0,
	      sceneCharaNanaName = void 0;
	  var sceneCharaFutabaIllust = void 0,
	      sceneCharaFutabaBody = void 0,
	      sceneCharaFutabaName = void 0;
	  var sceneCharaKaorukoIllust = void 0,
	      sceneCharaKaorukoBody = void 0,
	      sceneCharaKaorukoName = void 0;
	  var offsetStoryIllust = 0;
	  var offsetCharaIllust = 0;
	  var offsetCharaBody = 0;
	  var offsetCharaName = 0;
	
	  //オフセット設定
	  function animationOffsetSetting(e) {
	    if (e.matches) {
	      offsetStoryIllust = 300;
	      offsetCharaIllust = 100;
	      offsetCharaBody = 100;
	      offsetCharaName = 50;
	    } else {
	      offsetStoryIllust = 150;
	      offsetCharaIllust = 50;
	      offsetCharaBody = 0;
	      offsetCharaName = 30;
	    }
	  }
	  mediaQueryMd.addListener(animationOffsetSetting);
	  animationOffsetSetting(mediaQueryMd);
	
	  function isAnimated(targetElem) {
	    if (!$(targetElem).hasClass('is-animated')) {
	      $(targetElem).addClass('is-animated');
	    }
	  }
	
	  //オリジナルストーリー　メモワール
	  sceneStory = new ScrollMagic.Scene({
	    triggerElement: '.idx-Section_Story .idx-Section_Body',
	    triggerHook: 'onEnter',
	    reverse: false,
	    offset: offsetStoryIllust
	  }).on('enter', function () {
	    $('.idx-Section_Story .illust.karen').addClass('is-animated');
	    $('.idx-Section_Story .illust.chika').addClass('is-animated');
	    $('.idx-Section_Story .illust.mahiru_hikari').addClass('is-animated');
	  })
	  // .addIndicators()
	  .addTo(controller);
	
	  //コラボ舞台少女　星見純那
	  sceneCharaJunnaIllust = new ScrollMagic.Scene({
	    triggerElement: '.chara_wrapper.junna .illust',
	    triggerHook: 'onEnter',
	    reverse: false,
	    offset: offsetCharaIllust
	  }).on('enter', function () {
	    $('.chara_wrapper.junna .illust').addClass('is-animated');
	  })
	  // .addIndicators()
	  .addTo(controller);
	
	  sceneCharaJunnaBody = new ScrollMagic.Scene({
	    triggerElement: '.chara_wrapper.junna .body',
	    triggerHook: 'onEnter',
	    reverse: false,
	    offset: offsetCharaBody
	  }).on('enter', function () {
	    $('.chara_wrapper.junna .body').addClass('animating');
	
	    setTimeout(function () {
	      $('.chara_wrapper.junna .body').removeClass('animating').addClass('is-animated');
	    }, 900);
	  })
	  // .addIndicators()
	  .addTo(controller);
	
	  sceneCharaJunnaName = new ScrollMagic.Scene({
	    triggerElement: '.chara_wrapper.junna .name',
	    triggerHook: 'onEnter',
	    reverse: false,
	    offset: offsetCharaName
	  }).on('enter', function () {
	    $('.chara_wrapper.junna .name').addClass('is-animated');
	  })
	  // .addIndicators()
	  .addTo(controller);
	
	  //コラボ舞台少女　大場なな
	  sceneCharaNanaIllust = new ScrollMagic.Scene({
	    triggerElement: '.chara_wrapper.nana .illust',
	    triggerHook: 'onEnter',
	    reverse: false,
	    offset: offsetCharaIllust
	  }).on('enter', function () {
	    $('.chara_wrapper.nana .illust').addClass('is-animated');
	  })
	  // .addIndicators()
	  .addTo(controller);
	
	  sceneCharaNanaBody = new ScrollMagic.Scene({
	    triggerElement: '.chara_wrapper.nana .body',
	    triggerHook: 'onEnter',
	    reverse: false,
	    offset: offsetCharaBody
	  }).on('enter', function () {
	    $('.chara_wrapper.nana .body').addClass('animating');
	
	    setTimeout(function () {
	      $('.chara_wrapper.nana .body').removeClass('animating').addClass('is-animated');
	    }, 900);
	  })
	  // .addIndicators()
	  .addTo(controller);
	
	  sceneCharaNanaName = new ScrollMagic.Scene({
	    triggerElement: '.chara_wrapper.nana .name',
	    triggerHook: 'onEnter',
	    reverse: false,
	    offset: offsetCharaName
	  }).on('enter', function () {
	    $('.chara_wrapper.nana .name').addClass('is-animated');
	  })
	  // .addIndicators()
	  .addTo(controller);
	
	  //コラボ舞台少女　石動双葉
	  sceneCharaFutabaIllust = new ScrollMagic.Scene({
	    triggerElement: '.chara_wrapper.futaba .illust',
	    triggerHook: 'onEnter',
	    reverse: false,
	    offset: offsetCharaIllust
	  }).on('enter', function () {
	    $('.chara_wrapper.futaba .illust').addClass('is-animated');
	  })
	  // .addIndicators()
	  .addTo(controller);
	
	  sceneCharaFutabaBody = new ScrollMagic.Scene({
	    triggerElement: '.chara_wrapper.futaba .body',
	    triggerHook: 'onEnter',
	    reverse: false,
	    offset: offsetCharaBody
	  }).on('enter', function () {
	    $('.chara_wrapper.futaba .body').addClass('animating');
	
	    setTimeout(function () {
	      $('.chara_wrapper.futaba .body').removeClass('animating').addClass('is-animated');
	    }, 900);
	  })
	  // .addIndicators()
	  .addTo(controller);
	
	  sceneCharaFutabaName = new ScrollMagic.Scene({
	    triggerElement: '.chara_wrapper.futaba .name',
	    triggerHook: 'onEnter',
	    reverse: false,
	    offset: offsetCharaName
	  }).on('enter', function () {
	    $('.chara_wrapper.futaba .name').addClass('is-animated');
	  })
	  // .addIndicators()
	  .addTo(controller);
	
	  //コラボ舞台少女　花柳香子
	  sceneCharaKaorukoIllust = new ScrollMagic.Scene({
	    triggerElement: '.chara_wrapper.kaoruko .illust',
	    triggerHook: 'onEnter',
	    reverse: false,
	    offset: offsetCharaIllust
	  }).on('enter', function () {
	    $('.chara_wrapper.kaoruko .illust').addClass('is-animated');
	  })
	  // .addIndicators()
	  .addTo(controller);
	
	  sceneCharaKaorukoBody = new ScrollMagic.Scene({
	    triggerElement: '.chara_wrapper.kaoruko .body',
	    triggerHook: 'onEnter',
	    reverse: false,
	    offset: offsetCharaBody
	  }).on('enter', function () {
	    $('.chara_wrapper.kaoruko .body').addClass('animating');
	
	    setTimeout(function () {
	      $('.chara_wrapper.kaoruko .body').removeClass('animating').addClass('is-animated');
	    }, 900);
	  })
	  // .addIndicators()
	  .addTo(controller);
	
	  sceneCharaKaorukoName = new ScrollMagic.Scene({
	    triggerElement: '.chara_wrapper.kaoruko .name',
	    triggerHook: 'onEnter',
	    reverse: false,
	    offset: offsetCharaName
	  }).on('enter', function () {
	    $('.chara_wrapper.kaoruko .name').addClass('is-animated');
	  })
	  // .addIndicators()
	  .addTo(controller);
	
	  var windowScrollPos = 0;
	
	  function scrollAnimation(scrollPos) {
	    $('.js-fade_up').each(function () {
	      var targetElem = $(this);
	      var targetElemOffset = $(this).offset().top;
	
	      if (scrollPos + window.innerHeight > targetElemOffset) {
	        targetElem.addClass('is-animated');
	      }
	    });
	  }
	
	  $(window).on('load scroll', function () {
	    windowScrollPos = $(window).scrollTop();
	
	    scrollAnimation(windowScrollPos);
	  });
	};
	scrollAnimation();

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var windowScrollPos = 0;
	
	function _vwSP(size) {
	  var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 768;
	
	  windowWidth = window.innerWidth;
	  return size / base * windowWidth;
	}
	
	function _vwPC(size) {
	  var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1920;
	
	  windowWidth = window.innerWidth;
	  return size / base * windowWidth;
	}
	
	// ------------------------------------------------------------------------
	// スムーススクロール
	// ------------------------------------------------------------------------
	var smoothScroll = function smoothScroll() {
	  $('a[href^="#"]').on('click.smoothScroll', function () {
	    var linkSpeed = 400;
	    var linkHref = $(this).attr('href');
	    var linkTarget = $(linkHref == '#' || linkHref == '' ? 'html' : linkHref);
	    var linkPosition = linkTarget.offset().top;
	    var linkAdjust = 0;
	    $('html, body').animate({ scrollTop: linkPosition - linkAdjust }, linkSpeed, 'swing');
	    return false;
	  });
	};
	
	// ------------------------------------------------------------------------
	// YouTube動画モーダル表示
	// ------------------------------------------------------------------------
	var showYouTubeModal = function showYouTubeModal() {
	  //スムーススクロール無効
	  $('[data-trigger="youtube_modal"]').on('mouseenter', function () {
	    $(this).off('click.smoothScroll');
	  });
	
	  $('[data-trigger="youtube_modal"]').on('click', function () {
	    var youtubeID = $(this).attr('data-youtube-id');
	    var html = '';
	
	    //背景コンテンツ固定
	    windowScrollPos = $(window).scrollTop();
	    $('body').addClass('fixed').css({ 'top': -windowScrollPos });
	
	    //iframe設定
	    html = '<iframe src="https://www.youtube.com/embed/' + youtubeID + '?autoplay=1" width="800" height="450" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
	    $('.sw-YouTube_Modal .video_inner').append(html);
	
	    //モーダルボックス表示
	    $('.sw-YouTube_Modal').fadeIn(300);
	
	    return false;
	  });
	
	  // ---------- 閉じる ---------- //
	  function modalClose() {
	    //背景コンテンツ固定解除
	    $('body').removeClass('fixed').css({ 'top': '' });
	    $(window).scrollTop(windowScrollPos);
	
	    //モーダルボックス非表示
	    $('.sw-YouTube_Modal').fadeOut(200);
	
	    //コンテンツ破棄
	    setTimeout(function () {
	      $('.sw-YouTube_Modal .video_inner').html('');
	    }, 300);
	  }
	
	  $('.sw-YouTube_Modal .btn_close').on('click', function () {
	    modalClose();
	    return false;
	  });
	
	  $('.sw-YouTube_Modal').on('click', function () {
	    modalClose();
	    return false;
	  });
	};
	
	exports.smoothScroll = smoothScroll;
	exports.showYouTubeModal = showYouTubeModal;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app.bundle.js